import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HelpService } from '../../../../shared/services/help.service';
import { BillingService } from '../../../../shared/services/billing/billing.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../shared/services/auth.service';
import { ShipmentReviewModel } from '../../../../shared/models/billing/shipment-review.model';
import { ShipmentMasterService } from '../../../../shared/services/shipment-master.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-internal-review-dialog',
  templateUrl: './internal-review-dialog.component.html',
  styleUrls: ['./internal-review-dialog.component.scss'],
  standalone: false,
})
export class InternalReviewDialogComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  shipmentReviews: ShipmentReviewModel[];
  internalReviewForm: FormGroup;
  isLoading = false;

  private manageShipmentReviewSubs: Subscription;

  displayedColumns: string[] = ['createUser', 'createDate', 'comment'];
  dataSource: MatTableDataSource<ShipmentReviewModel>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort; // Optional for sorting

  constructor(
    private readonly dialogRef: MatDialogRef<InternalReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      shipment: any;
      load: any;
      manualAuditStatusID: number;
      carrierInvVersion: number;
    },
    private readonly formBuilder: FormBuilder,
    private readonly helpService: HelpService,
    private readonly billingService: BillingService,
    private readonly authService: AuthService,
    private readonly shipmentMasterService: ShipmentMasterService
  ) {}

  ngOnInit(): void {
    this.getShipmentReviews();
    this.createInternalReviewForm();
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  ngOnDestroy(): void {
    [this.manageShipmentReviewSubs].forEach((sub) => sub?.unsubscribe());
  }

  updateInternalReview(): void {
    this.isLoading = true;
    this.billingService
      .insertShipmentReview(this.internalReviewForm.value)
      .subscribe({
        next: () => {
          this.helpService.showMessageNotification(
            'Internal Review successfully Updated',
            'success'
          );
          this.isLoading = false;
          this.shipmentMasterService.getShipmentAndLoad(
            this.data.shipment.ShipmentID,
            this.data.load.LoadID
          );
          this.dialogRef.close(true);
        },
        error: () => {
          this.helpService.showMessageNotification(
            'Error! Please try again.',
            'danger'
          );
          this.isLoading = false;
        },
      });
  }

  dateFormatCST(date: string): string {
    return this.helpService.dateFormatCST(date);
  }

  private getShipmentReviews(): void {
    this.isLoading = true;

    this.manageShipmentReviewSubs = this.billingService
      .getShipmentReview(this.data.shipment.ShipmentID, 'I')
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.shipmentReviews = response || [];
          this.dataSource = new MatTableDataSource<ShipmentReviewModel>(
            this.shipmentReviews
          );
          if (this.paginator) {
            this.paginator.length = this.shipmentReviews.length;
            this.dataSource.paginator = this.paginator;
            this.dataSource.paginator.firstPage();
            this.dataSource.sort = this.sort;
          }
        },
        error: () => {
          this.helpService.showMessageNotification(
            'Error! Please try again.',
            'danger'
          );
          this.isLoading = false;
        },
      });
  }

  private createInternalReviewForm(): void {
    this.internalReviewForm = this.formBuilder.group({
      ShipmentID: [this.data.shipment.ShipmentID],
      ReviewType: ['I'],
      Comment: ['', Validators.required],
      ExpenseCodesID: [this.data?.shipment?.ExpenseCodeId],
      DirectionID: [this.data?.shipment?.DirectionsID],
      CustomerReviewStatusID: [null],
      ManualAuditStatusID: [ this.data.manualAuditStatusID || 1, Validators.required],
      CreateDate: [new Date()],
      CreateUser: [this.authService.userFullName],
      CarrierInvVersion: [this.data.carrierInvVersion || 1],
    });
  }

}
